import { render } from "./newsList.vue?vue&type=template&id=d6849fe2&scoped=true"
import script from "./newsList.vue?vue&type=script&lang=js"
export * from "./newsList.vue?vue&type=script&lang=js"

import "./newsList.vue?vue&type=style&index=0&id=d6849fe2&scoped=true&lang=css"

import exportComponent from "D:\\Web\\hkjt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6849fe2"]])

export default __exports__